export const MarkersTableInitializer = 'Markers';
export const MarkersTableComparator = 'createdAt';
